<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addEditPurchaseOrder></addEditPurchaseOrder>
    </v-dialog>
</template>

<script>
    import addEditPurchaseOrder from '../Shared/AddPurchaseOrder.vue'

    // Settings Types
    import {
        PurchaseOrder
    } from '../../store/namespace-helper'

    export default {
      name: 'purchase-order-dialog',
      components: {
        addEditPurchaseOrder
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[PurchaseOrder.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrders/AddPurchaseOrderDialog.vue